import { render, staticRenderFns } from "./CommunityInvoices.vue?vue&type=template&id=05638d16&scoped=true&"
import script from "./CommunityInvoices.vue?vue&type=script&lang=js&"
export * from "./CommunityInvoices.vue?vue&type=script&lang=js&"
import style0 from "./CommunityInvoices.vue?vue&type=style&index=0&id=05638d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05638d16",
  null
  
)

export default component.exports